import request from '@/utils/request'

export function pageFirmware (query) {
  return request({ url: '/cio/firmware/page', method: 'get', params: query })
}

export function getFirmware (id) {
  return request({ url: '/cio/firmware/detail', method: 'get', params: { id } })
}

export function addFirmware (data) {
  return request({ url: '/cio/firmware/add', method: 'post', data })
}

export function editFirmware (data) {
  return request({ url: '/cio/firmware/edit', method: 'post', data })
}

export function deleteFirmware (ids) {
  return request({ url: '/cio/firmware/delete', method: 'post', data: ids })
}

export function searchFirmwareWhitelistUsers (mobile) {
  return request({ url: '/cio/firmware/whitelist/users', method: 'get', params: { mobile } })
}
